import useUserStore from '@/stores/userStore';

interface UseRoleResult {
  roles: string[];
  hasRole: (...required: string[]) => boolean;
  hasAnyRole: (...candidates: string[]) => boolean;
}

const useRole = (): UseRoleResult => {
  const user = useUserStore((state) => state.user);
  const roles = (user?.roles ?? []) as string[];

  const hasRole = (...required: string[]) => {
    if (!required.length) return true;
    return required.every((role) => roles.includes(role));
  };

  const hasAnyRole = (...candidates: string[]) => {
    if (!candidates.length) return true;
    return candidates.some((role) => roles.includes(role));
  };

  return { roles, hasRole, hasAnyRole };
};

export default useRole;
